"use strict";
/* eslint-disable import/prefer-default-export, camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockUserJobs = void 0;
exports.mockUserJobs = {
    active: {
        '86': {
            id: '86',
            name: 'createAssignedLessons',
            data: {
                userUuid: '261d4b4e-a95f-4703-918e-5367acab45c4',
                tenant: 'test',
                assignedBy: '261d4b4e-a95f-4703-918e-5367acab45c4',
                lessonAssignments: [
                    {
                        userUuid: '206fb4ce-b409-4751-8bae-0bae4d5f90a3',
                        lessonUuid: 'dc1202eb-eda6-4594-9ea4-69756f67481c',
                    },
                    {
                        userUuid: '206fb4ce-b409-4751-8bae-0bae4d5f90a3',
                        lessonUuid: '8e5071a8-c0ae-4937-a813-3da77c279b66',
                    },
                    {
                        userUuid: '206fb4ce-b409-4751-8bae-0bae4d5f90a3',
                        lessonUuid: 'aa9f751a-0288-4d1c-a9eb-a1a64f4d3626',
                    },
                ],
            },
            progress: {
                step: 1,
                totalSteps: 3,
            },
            returnvalue: {
                success: true,
            },
            duration: 215,
        },
    },
};
